const contractDelegation = {
  computed: {
    contracts() {
      const getterContracts = this.$store.getters['contracts/get'];
      return Array.isArray(getterContracts) ? getterContracts : [];
    },
    hasNonDelegatedContract() {
      return this.contracts.some(({ delegation }) => delegation === false);
    },
    useGoCardless() {
      return !this.hasNonDelegatedContract;
    },
  },
  methods: {
    async ensureContractsLoaded() {
      if (Array.isArray(this.contracts) && this.contracts.length > 0) {
        return;
      }
      try {
        await this.$store.dispatch('orders/setOrders');
      } catch (err) {
        console.error('Failed to load contracts:', err);
      }
    },
  },
};

export default contractDelegation;
